module.exports = __webpack_public_path__ + "img/mir.c6f04bb8.png";